import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { AirconRepair } from '../../../components/index/service-category/aircon-service/AirconRepair'
import { Services } from '../../../components/index/service/Services'
import { BottomButtons } from '../../../components/index/service-category/aircon-service/BottomButtons'
import Link from 'next/link'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHvacServices, getWpNewHvacServices, setWpHvacServices, setWpNewHvacServices } from '../../../service/wp-blogs-store'
import { AirconQuickLinks } from '../../../components/index/service-category/aircon-service/AirconQuickLinks'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    let lat = 1.3521
    let lng = 103.8198
    const { month, year } = getArticleDateTime();
    const modifiedDate = reviewedIso(CONTENT_REVIEWED);
    const airconBlogs = blogsMaster['hvac-services'].blogArray;
    const wpPosts = getWpHvacServices().length > 0 ?  getWpHvacServices() : await getWpPostsByCategory(6, "hvac-services");
    setWpHvacServices(wpPosts)
    const wpNewPosts = getWpNewHvacServices().length > 0 ?  getWpNewHvacServices() : await getWpNewPostsByCategory(6, "hvac-services");
    setWpNewHvacServices(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        wpNewPosts,
        wpPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const countryName = "Singapore"
    const requestType = "Aircon Services"

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

    const maxRating = [1, 2, 3, 4, 5]

  return (
    <>
      <Head>
        <title>Complete Guide for Aircon Installation In Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Need help installing a new Aircon? Open a request now get the best affordable aircon installation service in Singapore!"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Complete Guide for Aircon Installation In Singapore`}/>
        <meta property="og:description" content="Need help installing a new Aircon? Open a request now get the best affordable aircon installation service in Singapore!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-02T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation"/>
        <meta name="twitter:title" content={`Complete Guide for Aircon Installation In Singapore`}/> 
        <meta name="twitter:description" content="Need help installing a new Aircon? Open a request now get the best affordable aircon installation service in Singapore!"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/aircon-installation',
            pageName: 'Complete Guide for Aircon Installation In Singapore',
            description: 'Need help installing a new Aircon? Open a request now get the best affordable aircon installation service in Singapore!',
            serviceName: 'Aircon Installation Singapore',
            serviceType: 'Aircon Installation',
            image: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg',
            datePublished: '2025-01-02T07:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Aircon Installation',
          })) }}
        />
        </Head>
        <div>
            {/* Hero H1 lives in AirconRepair; the body heading below is an H2. This
                replaced AirconServiceRequestForm, which auto-opened the question
                wizard on page load. */}
            <RequestProvider>
                <section id="aircon-installation" className='relative'>
                    <AirconRepair
                        setRequestForm={setRequestForm}
                        setIsQuickBook={setIsQuickBook}
                        title="Aircon Installation Guide"
                        problem="New aircon installation"
                        heroImage="blog/living/aircon-installation.jpg"
                        subtitle="Tell us the aircon brand, model and number of units - we will quote the installation."
                        inputLabel="What do you need installed?"
                    />
                </section>
                {!requestForm &&
                    <BottomButtons countryName={countryName}/>
                }
                {requestForm &&
                    <Services
                        requestType={requestType}
                        requestCategorySettings={requestCategorySettings}
                        setRequestForm={setRequestForm}
                        isQuickBook={isQuickBook}
                        isCustomBook={false}
                        asSheet
                    />
                }
            </RequestProvider>
            <div className='max-w-5xl mx-auto py-5 px-2 leading-8'>
                <div className='space-y-2 py-5'>
                    <h2 className='text-3xl md:text-4xl text-center font-semibold'>Aircon Installation Guide</h2>
                    {/* <div className='text-gray-400 text-xs'>
                        <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                    </div> */}
                </div>
                <div className='py-2 space-y-5'>
                    <p className=''>
                        Moving in to a new house or just want to replace your Aircon? Everything you need to know about a new Aircon installation.
                    </p>
                    <div className='space-y-2'>
                        <h3 className='text-lg font-bold'>
                            Topic Highlights
                        </h3>
                        <ul className='px-4'>
                            <li className='list-disc'>Which Aircon brand to buy</li>
                            <li className='list-disc'>Which type of Aircon to buy</li>
                            <li className='list-disc'>How many fan units should the aircon have</li>
                            <li className='list-disc'>What is the cost of Aircon installation</li>
                            <li className='list-disc'>How long does it take for Aircon installation</li>
                        </ul>
                    </div>                        
                    <div className='relative h-96'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/aircon-installation.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='technician installing the aircon unit'
                        />          
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-lg font-bold'>Which Aircon Brand To Buy</h2>
                        <div className='space-y-2'>
                            <p>
                                There are quite a few popular and trusted air con brands that you can choose from like -
                                &nbsp;<a target="_blank" rel="noreferrer nofollow noopener" href='https://www.lg.com/' className='text-orange-600'>LG</a>
                                ,&nbsp;<a target="_blank" rel="noreferrer nofollow noopener" href='https://www.daikin.com/' className='text-orange-600'>Daikin</a>
                                ,&nbsp;<a target="_blank" rel="noreferrer nofollow noopener" href="https://www.mitsubishielectric.com/" className='text-orange-600'>Mitsubishi</a>
                                ,&nbsp;<a target="_blank" rel="noreferrer nofollow noopener" href="https://www.panasonic.com/sg/consumer/air-conditioners.html" className='text-orange-600'>Panasonic</a>
                                &nbsp;and many more. If you have a favorite brand go for it, they are all good or 
                            </p>
                        </div>                        
                        <div className='text-center py-5'>
                            <Link href="/sg/aircon-servicing-singapore/compare-top-air-conditioner-brands-in-singapore" className='px-4 py-3 text-orange-600 rounded border border-amber-600'>
                                Compare Air Conditioner Brands
                            </Link>
                        </div>
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-lg font-bold'>Which Type Of Aircon To Buy</h2>
                        <div className='space-y-2'>
                            <p>
                                You can either go for a window Aircon or split AC.                                    
                            </p>
                            <p>
                                <strong>1. Window AC - </strong>A window aircon as the name suggests is attached to the window with the fan facing inside the room and the condenser facing outside. This is a
                                cheaper option and works well when you just have one room to cool. Off course, the window design of your apartment or house must support this
                                installation                                   
                            </p>
                            <p>
                                <strong>2. Split Aircon - </strong>In a split AC the condenser and the fan are separated. The condenser is installed out the house, most of the time
                                it is hanging outside the apartment. Whereas the fan units are installed inside the rooms of your house. This is must neater installation, but would 
                                require some drilling of the walls to place the pipes connecting the condenser and fan units. Split aircon are recommended when you want one condenser
                                to cool more than one room or when your room design does not support installation of window aircon            
                            </p>
                        </div>
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-lg font-bold'>How Many Aircon Fan Units Should You Buy</h2>
                        <div className='space-y-2'>
                            <p>
                                This is applicable to split AC only. The number of Aircon fan unit units you need is proportionate to the number of rooms you would like to cool in 
                                the house. It also depending on the cooling capacity of the condenser. You cannot have too many fan units for low cooling capacity condenser. 
                                Additionally, when the room size is big you may need a fan unit with higher cooling capacity as well. Check with your
                                Aircon service provider for better clarification on what is the suited for your house and room size.                                  
                            </p>
                        </div>
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-lg font-bold'>Aircon Installation Cost</h2>
                        <div className='space-y-2'>
                            <p>
                                The cost of Aircon installation depends on the type of Aircon you select and also the number of fan units. Open a request to get pricing details.
                                One of the Aircon service provider representative will do an initial inspection of your house based on your requirements and then provide you with
                                quotations.                                 
                            </p>
                        </div>
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-lg font-bold'>How Long Does It Take For Aircon Installation</h2>
                        <div className='space-y-2'>
                            <p>
                                After you agree to the quotations provided by the representative, the Aircon company will work out the installation date with you.
                                If it is a working day, we recommended working from home or taking the day off as it might take the entire day to finish the installation. 
                                Expect your house to get dirty with dusts from the drilling, so ensure to cover you interiors with plastic until the work is done. You would need to
                                do a thorough house cleaning later to remove the dusts.                               
                            </p>
                            <p>
                                Make sure to test the Aircon cooling, oscillation and other functions with the provide remote control before you let the technicians leave.                            
                            </p>
                        </div>
                    </div>
                </div> 
                <div className='text-center py-10 relative'>
                    <div className='relative w-full h-120'>
                        <Image
                            src={s3Static + "blog/living/repairman-doing-air-conditioner-service.jpg"}
                            fill
                            style={{objectFit: 'cover', objectPosition: 'center'}}   
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Join us as an Aircon Service Provider - StringsSG'
                        />     
                    </div> 
                    <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                        <Link href="/sg/aircon-servicing-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                                Request for Aircon Cleaning Service
                        </Link>       
                    </div>  
                </div>
            </div>
            <BlogsList blogs={airconBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
            {/* <AirconQuickLinks/> */}
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
